
$(document).ready(function(){

//set values
var firstName = localStorage.getItem('checkout_firstName');
var lastName  = localStorage.getItem('checkout_lastName');
var email     = localStorage.getItem('checkout_email');
var phone     = localStorage.getItem('checkout_phone');
var country   = localStorage.getItem('checkout_country');
var province  = localStorage.getItem('checkout_province');
var address1  = localStorage.getItem('checkout_address1');

if(firstName){$("input[name='shipping_address[first_name]']").val(firstName);}
if(lastName){$("input[name='shipping_address[last_name]']").val(lastName);}
if(email){$("input[name='shipping_address[email]']").val(email);}
if(phone){$("input[name='shipping_address[phone]']").val(phone);}
if(country){$("select[name='shipping_address[country]']").val(country);}
if(province){$("select[name='shipping_address[province]']").val(province);}
if(address1){$("input[name='shipping_address[address1]']").val(address1);}
  
var width = $(window).width();
  console.log(width)
  if(width < 769){
    $('.check-inner button#shipping-address-btn,.check-inner button#continue-payment,.check-inner button#process-payment').insertAfter('.check-right');
  }

 $(window).on('resize', function(){
    var win = $(this); //this = window
    if (win.height() >= 820) { /* ... */ }
    if (win.width() < 769) {
      $('.check-inner button#shipping-address-btn,.check-inner button#continue-payment,.check-inner button#process-payment').insertAfter('.check-right');
    }else{
      $('button#shipping-address-btn,button#continue-payment,button#process-payment').insertAfter('.check-inner .cart_total');
    }
 });

  
 $(".accordion").on("click", ".heading", function() {
   $(this).toggleClass("active").next().slideToggle();
   $(".contents").not($(this).next()).slideUp(300);        
   $(this).siblings().removeClass("active");
 });

 $('.app-coupon').click(function(){
      $(this).toggleClass('active');
    $('.coup-code-form').toggleClass('open');
 });

 $('#pickup-data').click(function(){
    $("#shipping-address-btn").toggle();
    $("#continue-payment").toggle();
 });

 $('#shipping-data').click(function(){
    $("#shipping-address-btn").show();
    $("#continue-payment").hide();
    
 });
  
});

$(document).ready(function(){
 $(".order-toggle").click(function() {
   $(".order-toggle").toggleClass("active");
   $("#item-show").toggle();
   $("#item-hide").toggle();
   
 });
});

const url_var = window.location.origin;
const domain = 'go-sport-uae.myshopify.com';
const storefrontAccessToken = '5f6d3670041e6b123e33dfb5cd47a149';
const endpoint = 'https://'+domain+'/api/2023-04/graphql.json';
const adminApiToken = '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';

let shippingAddress = (billingAddress = {});
let discountCode = checkoutId = fullCheckoutObj = notes = poNumber = discountCodeObj = customerId = null;
let lineItemsToAdd = [];
let checkoutShippingAmount = checkoutSubTotal = disountAmount = checkoutTotal = 0;
let nextStep = false;

var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);

const fetchCheckoutMutation = `query GetCheckoutValues($checkoutId: ID!) {
  node(id: $checkoutId) {
    id
    ... on Checkout {   
        id
        email
        ready
        completedAt
        subtotalPriceV2 {
          amount
          currencyCode
        }
        shippingAddress {
            firstName
            lastName
            address1
            city
            province
            country
            zip
            phone
        }
        discountApplications(first: 1) {
            edges {
                node {
                    allocationMethod
                    targetSelection
                    targetType
                    value {
                        ... on MoneyV2 {
                            amount
                            currencyCode
                        }
                        ... on PricingPercentageValue {
                            percentage
                        }
                    }
                }
            }
        }
        availableShippingRates {
          ready
          shippingRates {
            handle
            title
            priceV2 {
              amount
              currencyCode
            }
          }
        }
        currencyCode
        taxesIncluded
        totalPriceV2 {
            amount
            currencyCode
        }
        lineItemsSubtotalPrice {
          amount
          currencyCode
        }
        lineItems(first: 250) {
            edges {
                node {
                    id
                    title
                    quantity
                    variant {
                        id
                        title
                        priceV2 {
                            amount
                            currencyCode
                        }
                        product {
                            id
                        }
                    }
                }
            }
        }
        webUrl
    }
  }
}`;

const updateShippingAddressMutation = `mutation checkoutShippingAddressUpdateV2($checkoutId: ID!, $shippingAddress: MailingAddressInput!) {
  checkoutShippingAddressUpdateV2(checkoutId: $checkoutId, shippingAddress: $shippingAddress) {
    checkout {
        id
    }
    checkoutUserErrors {
        code
        field
        message
    }
  }
}`;

const updateEmail = `mutation checkoutEmailUpdateV2($checkoutId: ID!, $email: String!) {
  checkoutEmailUpdateV2(checkoutId: $checkoutId, email: $email) {
    checkout {
      id
    }
    checkoutUserErrors {
        code
        field
        message
    }
  }
}`;

const createCheckoutMutation = `
  mutation checkoutCreate($input: CheckoutCreateInput!) {
    checkoutCreate(input: $input) {
      checkout {
        id
    }
  }
}`;

const applyDiscountCodeMutation = `
  mutation checkoutDiscountCodeApplyV2($checkoutId: ID!, $discountCode: String!) {
  checkoutDiscountCodeApplyV2(checkoutId: $checkoutId, discountCode: $discountCode) {
      checkout {
          id
      }
      checkoutUserErrors {
          code
          field
          message
      }
    }
}`;

const removeDiscountCodeMutation = `
  mutation checkoutDiscountCodeRemove($checkoutId: ID!) {
  checkoutDiscountCodeRemove(checkoutId: $checkoutId) {
    checkout {
        id
    }
    checkoutUserErrors {
        field
        message
    }
  }
}`;

const shippingLineMutation = `mutation checkoutShippingLineUpdate($checkoutId: ID!, $shippingRateHandle: String!) {
  checkoutShippingLineUpdate(checkoutId: $checkoutId, shippingRateHandle: $shippingRateHandle) {
    checkout {
      id
    }
    checkoutUserErrors {
      field
      message
    }
  }
}`;


async function setPickupDeliveryMethod(checkoutId, selectedShippingRateHandle) {
  // Get available shipping rates
  const getShippingRatesQuery = `
    mutation {
      checkoutShippingRatesUpdateV2(checkoutId: "${checkoutId}", shippingRates: {}) {
        checkout {
          id
          availableShippingRates {
            ready
            shippingRates {
              handle
              price
              title
            }
          }
        }
      }
    }
  `;
}

function prepareLineItems() {
    let lineItems = [];
    return fetch(url_var + "/cart.js", {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        },
    }).then((response) => response.json())
    .then((data) => {
        cartItemData = data.items;

        if (cartItemData.length !== 0) {
            $.each(cartItemData, function (index, value) {
                var itemObj = {
                    variantId: "gid://shopify/ProductVariant/" + value.id,
                    quantity: value.quantity,
                };
                lineItems.push(itemObj);
            });
        }
        return lineItems;
    }).catch((error) => {
        console.error("prepare cart => ", error);
    });
}

function createNewCheckout(lineItemsToAdd) {
    var graphql = JSON.stringify({
        query: createCheckoutMutation,
        variables: {
        input: {
            lineItems: lineItemsToAdd,
        },
        },
    });
    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
    };

    return fetch(endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
        if ("errors" in result === true) {
            if (result.errors.length > 0) {
                $(".shipping-error-msg").text(result.errors[0].message).show();
                nextStep = false;
                return false;
            }
        }
        return result;
    })
    .catch((error) => {
        console.log("create checkout => ", error);
        $(".shipping-error-msg").text("Something went wrong!").show();
    });
}

async function applyDiscount(checkoutId, discountCode) {
    var graphql = JSON.stringify({
        query: applyDiscountCodeMutation,
        variables: {
        checkoutId: checkoutId,
        discountCode: discountCode,
        },
    });
    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
    };

    return fetch(endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
        if (result.data.checkoutDiscountCodeApplyV2.checkoutUserErrors.length > 0) {
            $(".discount-error-msg")
            .text(
                result.data.checkoutDiscountCodeApplyV2.checkoutUserErrors[0]
                .message
            )
            .show();

            // remove discount
            removeDiscount(checkoutId);
            discountCodeObj = null;

            // hide discount
            $(".cart_discount")
            .find(".discount-text span b")
            .text("");
            $(".cart_discount")
            .find(".cart_discount_small")
            .text("");
            $(".cart_discount").hide();
            $(".discount-box").find("span.discount-text").find("span b").text("");
            $(".discount-box").find("span.discount-text").hide();
            
        }
    }).catch((error) => {
        console.log("apply discount => ", error);
        if ($(".shipping-error-msg").is(":visible")) {
            $(".shipping-error-msg").text("Something went wrong!").show();
        } else {
            $(".billing-error-msg").text("Something went wrong!").show();
        }
    });
}

async function removeDiscount(checkoutId) {
    var graphql = JSON.stringify({
        query: removeDiscountCodeMutation,
        variables: {
        checkoutId: checkoutId,
        },
    });
    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
    };

    return fetch(endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
        if (result.data.checkoutDiscountCodeRemove.checkoutUserErrors.length > 0) {
            $(".discount-error-msg")
            .text(
                result.data.checkoutDiscountCodeRemove.checkoutUserErrors[0].message
            )
            .show();
        }
        discountCodeObj = null;
    }).catch((error) => {
        console.log("remove discount => ", error);
        if ($(".shipping-error-msg").is(":visible")) {
            $(".shipping-error-msg").text("Something went wrong!").show();
        } else {
            $(".billing-error-msg").text("Something went wrong!").show();
        }
    });
}

function createOrderFromCheckout(checkoutObj, discountCodeObj, billingAddress) {
  
    console.log("checkoutObj.lineItems => ", checkoutObj, discountCodeObj, billingAddress);
    var lineItemsArray = [];
    var shippingRateArrayObj = [];
    if (checkoutObj.data.node.lineItems.edges.length !== 0) {
        $.each(checkoutObj.data.node.lineItems.edges, function (index, value) {
        var itemObj = {
            variant_id: value.node.variant.id.split("/").at(-1),
            quantity: value.node.quantity,
        };
        lineItemsArray.push(itemObj);
        });
    }
    console.log("lineItemsArray => ", lineItemsArray);
    if (checkoutObj.data.node.availableShippingRates.shippingRates.length !== 0) {
        $.each(checkoutObj.data.node.availableShippingRates.shippingRates, function (index, value) {
            var itemObj = {
            title: value.title,
            price: value.priceV2.amount,
            code: value.title,
            };
            shippingRateArrayObj.push(itemObj);
        });
    }

    var myAdminHeaders = new Headers();
    myAdminHeaders.append("Content-Type", "application/json");
    myAdminHeaders.append("X-Shopify-Access-Token", adminApiToken);
    myAdminHeaders.append("Cookie", "request_method=POST");

    var raw = JSON.stringify({
        order: {
        line_items: lineItemsArray,
        discount_codes: discountCodeObj,
        shipping_address: {
            first_name: checkoutObj.data.node.shippingAddress.firstName,
            last_name: checkoutObj.data.node.shippingAddress.lastName,
            address1: checkoutObj.data.node.shippingAddress.address1,
            address2: checkoutObj.data.node.shippingAddress.address2,
            city: checkoutObj.data.node.shippingAddress.city,
            province: checkoutObj.data.node.shippingAddress.province,
            country: checkoutObj.data.node.shippingAddress.country,
            zip: checkoutObj.data.node.shippingAddress.zip,
            phone: checkoutObj.data.node.shippingAddress.phone,
        },
        customer: {
            id: customerId,
        },
        payment_gateway_names: ["Cash on Delivery (COD)"],
        billing_address: billingAddress,
        note: notes,
        shipping_lines: shippingRateArrayObj,
        financial_status: "pending",
        total_price: checkoutTotal,
        currency: checkoutObj.data.node.totalPriceV2.currencyCode,
        },
    });

    console.log("raw => ", raw);
    var requestOptions = {
        method: "POST",
        headers: myAdminHeaders,
        body: raw,
        redirect: "follow"
    };

    fetch("https://" + domain + "/admin/api/2023-04/orders.json", requestOptions)
    .then((response) => response.json())
    .then((result) => {
        console.log("result => ", result);
        console.log("order_status_url => ", result.order.order_status_url);
        window.location.href = result.order.order_status_url;
    }).catch((error) => {
        $(".error-msg").text("Something went wrong in discount!").show();
        console.log("create order error", error);
    });
}

$(document).ready(async function () {
  // papare line items array & checkout object
  lineItemsToAdd = await prepareLineItems();
  var getcreatedCheckoutObj = await createNewCheckout(lineItemsToAdd);
  console.log("getcreatedCheckoutObj => ", lineItemsToAdd, getcreatedCheckoutObj);
  if (getcreatedCheckoutObj == null || getcreatedCheckoutObj == undefined) {
    return false;
  }
  checkoutId = getcreatedCheckoutObj.data.checkoutCreate.checkout.id;

  await updateCheckoutObj(checkoutId);
});

// billing toggle
$(".billing-addbox").click(function () {
  $(".billing-addbox").each(function (index) {
    if ($(this).find("input[name='adress']").is(":checked")) {
      $(this).closest(".toggle-lable").addClass("selected");
    } else {
      $(this).find("input[name='adress']").removeAttr("checked");
      $(this).closest(".toggle-lable").removeClass("selected");
    }
  });
});

// remove discount
$(document).on("click", ".remove-discount", async function () {
  await removeDiscount(checkoutId);
  updateCheckoutObj(checkoutId);
});

$(".custom-checkout-section #return-shippinginfo").click(function () {
  $(this).parents().find("#shipping-calculator").show();
  $(this).parents().find("#shipping-method").hide();
  nextStep = false;
});
$(".custom-checkout-section #continue-payment").click(function () {
  console.log("sadadsa ---"+checkoutId);
  $(this).parents().find("#payment-billing").show();
  $(this).parents().find("#shipping-method").hide();
  $(this).parents().find("#shipping-calculator").hide();
});
$(".custom-checkout-section #return-shipping").click(function () {
  $(this).parents().find("#shipping-calculator").hide();
  $(this).parents().find("#shipping-method").show();
  $(this).parents().find("#payment-billing").hide();
});

// get shipping address from form
$(document).on("click", "#shipping-address-btn", async function () {
    $(".error").text("").hide();
    if($('#shipping-data').hasClass('active')){
      shippingAddress = {
          firstName: $("input[name='shipping_address[first_name]']").val() ? $("input[name='shipping_address[first_name]']").val() : "",
          lastName: $("input[name='shipping_address[last_name]']").val() ? $("input[name='shipping_address[last_name]']").val() : "",
          city: $('#shipping_address_province').find(":selected").text() ? $('#shipping_address_province').find(":selected").text() : "",
          phone: $("input[name='shipping_address[phone]']").val() ? $("input[name='shipping_address[phone]']").val() : "",
          company: $("input[name='shipping_address[company]']").val() ? $("input[name='shipping_address[company]']").val() : "",
          address1: $("input[name='shipping_address[address1]']").val() ? $("input[name='shipping_address[address1]']").val() : "",
          address2: $("input[name='shipping_address[address2]']").val() ? $("input[name='shipping_address[address2]']").val() : "",
          zip: $("input[name='shipping_address[zip]']").val() ? $("input[name='shipping_address[zip]']").val() : "",
          province: $("select[name='shipping_address[province]']").val() ? $("select[name='shipping_address[province]']").val() : "",
          country: $("select[name='shipping_address[country]']").val() ? $("select[name='shipping_address[country]']").val() : "",
      };

      Object.keys(shippingAddress).map(function (key, index) {
          if (shippingAddress[key] == "") {
          shippingAddress[key] = null;
          }
      });

      console.log("shippingAddress => ", shippingAddress);
      var email = $("input[name='shipping_address[email]']").val() ? $("input[name='shipping_address[email]']").val() : "";
      //validation start
      $('.error_msg').remove();
      var validRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      var phone_regex = /^(?:\+971|00971|0)(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$/;
      var phone_regex_2 = /^(?:\971|00971|0)(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$/;
      var phone_regex_3 = /^(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$/;
      if(!shippingAddress.firstName){
        var error = '<p class="error_msg">Enter First Name</p>';
        $(error).insertAfter('#shipping_address_first_name');
      }
      if(!shippingAddress.lastName){
        var error = '<p class="error_msg">Enter Last Name</p>';
        $(error).insertAfter('#shipping_address_last_name');
      }
      if(!email){
        var error = '<p class="error_msg">Enter Email</p>';
        $(error).insertAfter('#shipping_address_email');
      }

      if(!shippingAddress.phone){
        var error = '<p class="error_msg">Enter Phone Number</p>';
        $(error).insertAfter('#shipping_address_phone');
        return false;
      }else if(!phone_regex.test(shippingAddress.phone) && !phone_regex_2.test(shippingAddress.phone) && !phone_regex_3.test(shippingAddress.phone)){
        var error = '<p class="error_msg">Enter Valid Phone Number</p>';
        $(error).insertAfter('#shipping_address_phone');
         return false;
      }
     
      if(!shippingAddress.address1){
        var error = '<p class="error_msg">Enter Address</p>';
        $(error).insertAfter('#shipping_address_address1');
      }
      localStorage.setItem('checkout_firstName', shippingAddress.firstName);
      localStorage.setItem('checkout_lastName', shippingAddress.lastName);
      localStorage.setItem('checkout_email', email);
      localStorage.setItem('checkout_phone', shippingAddress.phone);
      localStorage.setItem('checkout_country', shippingAddress.country);
      localStorage.setItem('checkout_province', shippingAddress.province);
      localStorage.setItem('checkout_address1', shippingAddress.address1);

        
      //validation end
        
      if (shippingAddress) {
          nextStep = false;
          updatedShippingObj = await updateShippingAddress(checkoutId, shippingAddress);
          console.log("updatedShippingObj----"+updatedShippingObj);
          if (updatedShippingObj) {
              billingAddress = shippingAddress;
          } else {
              return false;
          }
      }
      await updateCheckoutObj(checkoutId);
  
      if (nextStep) {
          $(this).parents().find("#shipping-calculator").hide();
          $(this).parents().find("#shipping-method").show();
          $(".accordion").hide();
          $("#shipping-address-btn").hide();
          $("#continue-payment").show();
          $("#tab-delivery").removeClass("active");
          $("#tab-shipping").addClass("active");
          nextStep = false;
      }
    }
});

// apply discount or remove
$(document).on("click", "#apply-discount", async function () {
    $(".error").text("").hide();
    discountCode = $("#discount_code").val() ? $("#discount_code").val() : null;
  console.log(discountCode);
    if (checkoutId != null) {
        if (discountCode != null) {
            checkoutWithDiscount = await applyDiscount(checkoutId, discountCode);
            isDiscount = true;
        } else {
            checkoutWithDiscount = await removeDiscount(checkoutId);
        }
        await updateCheckoutObj(checkoutId);
    }
    await updateCheckoutObj(checkoutId);
});

// get billing address from form
$(document).on("click", "#process-payment", async function () {
    
    billingAddress = {
      first_name: $("input[name='billing_address[first_name]']").val() ? $("input[name='billing_address[first_name]']").val() : null,
      last_name: $("input[name='billing_address[last_name]']").val() ? $("input[name='billing_address[last_name]']").val() : null,
      city: $("input[name='billing_address[city]']").val() ? $("input[name='billing_address[city]']").val() : null,
      phone: $("input[name='billing_address[phone]']").val() ? $("input[name='billing_address[phone]']").val() : null,
      company: $("input[name='billing_address[company]']").val() ? $("input[name='billing_address[company]']").val() : null,
      address1: $("input[name='billing_address[address1]']").val() ? $("input[name='billing_address[address1]']").val() : null,
      address2: $("input[name='billing_address[address2]']").val() ? $("input[name='billing_address[address2]']").val() : null,
      zip: $("input[name='billing_address[zip]']").val() ? $("input[name='billing_address[zip]']").val() : null,
      province: $("select[name='billing_address[province]']").val() ? $("select[name='billing_address[province]']").val() : null,
      country: $("select[name='billing_address[country]']").val() ? $("select[name='billing_address[country]']").val() : null,
    };
  
    await updateCheckoutObj(checkoutId);

    console.log(
        "create an order using  => ", fullCheckoutObj, discountCodeObj, billingAddress
    );
    createOrderFromCheckout(fullCheckoutObj, discountCodeObj, billingAddress);
});

async function updateShippingLine(checkoutId, shippingRateHandle) {
    var graphql = JSON.stringify({
        query: shippingLineMutation,
        variables: {
        checkoutId: checkoutId,
        shippingRateHandle: shippingRateHandle,
        },
    });
    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
    };

    return fetch(endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
        return result;
    }).catch((error) => {
        return false;
    });
}


async function updateemailaddress(checkoutId,customerEmail) {
    var graphql = JSON.stringify({
        query: updateEmail,
        variables: {
          checkoutId: checkoutId,
          email: customerEmail,
        },
    });
    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
    };

    return fetch(endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
        return result;
    }).catch((error) => {
        return false;
    });
}

// showing the payment option
$(document).on("click", "#continue-payment", async function () {
    
    if($('#shipping-data').hasClass('active')){
      fullCheckoutObj1 = await fetchCheckout(checkoutId);
      // $("#shipping-method").hide();
      // $(".payment-option").show();
      // $("#tab-delivery").removeClass("active");
      // $("#tab-shipping").removeClass("active");
      // $("#tab-payment").addClass("active");
      // $("#continue-payment").hide();
      // $("#process-payment").show();
      // $(".order-details-wrapper").hide();
      var webUrl = fullCheckoutObj1.data.node.webUrl;
      window.location.href = webUrl;
    }else{
      var email = $("input[name='billing_address[email]']").val() ? $("input[name='billing_address[email]']").val() : "";
      await updateemailaddress(checkoutId,email);

      shippingRateHandle = "shopify-Mall%20of%20Emirates-0.00";
      ddd = await updateShippingLine(checkoutId,shippingRateHandle);
      console.log(ddd);

//        selectedShippingRateHandle = 'shopify-Mall%20of%20Emirates-0.00';
//       updatedCheckout = await setPickupDeliveryMethod(checkoutId, selectedShippingRateHandle);
// console.log(updatedCheckout);
      // fullCheckoutObj1 = await fetchCheckout(checkoutId);

      
      // $("#tab-delivery").removeClass("active");
      // $("#tab-shipping").removeClass("active");
      // $("#tab-payment").addClass("active");
      // $(".payment-option").show();
      // $(".accordion").hide();
      // $("#continue-payment").hide();
      // $("#process-payment").show();
      // $(".order-details-wrapper").hide();
      var webUrl = fullCheckoutObj1.data.node.webUrl;
      window.location.href = webUrl;
    }
});


// process to payment
$(document).on("click", "#process-payment", async function () {
    await updateCheckoutObj(checkoutId);
    createOrderFromCheckout(fullCheckoutObj, discountCodeObj);
});

async function fetchCheckout(checkoutId) {
    var graphql = JSON.stringify({
        query: fetchCheckoutMutation,
        variables: {
        checkoutId: checkoutId,
        },
    });
    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
    };

    return fetch(endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
        return result;
    }).catch((error) => {
        console.log("fetched checkout error => ", error);
        $(".shipping-error-msg").text(error.errors[0].message);
        $(".shipping-error-msg").show();
        return false;
    });
}



async function updateShippingAddress(checkoutId, shippingAddress) {
  
    var email = $("input[name='shipping_address[email]']").val() ? $("input[name='shipping_address[email]']").val() : "";
    await updateemailaddress(checkoutId,email);
    console.log("email data==>",email);
    var graphql = JSON.stringify({
        query: updateShippingAddressMutation,
        variables: {
        checkoutId: checkoutId,
        shippingAddress: shippingAddress,
        },
    });
    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
    };

    return fetch(endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      var email = $("input[name='shipping_address[email]']").val() ? $("input[name='shipping_address[email]']").val() : "";
      var validRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      var phone_regex = /^(?:\+971|00971|0)(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$/;
      var phone_regex_2 = /^(?:\971|00971|0)(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$/;
      var phone_regex_3 = /^(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$/;
      
        console.log("shipping result => ", result);
        if (result.data.checkoutShippingAddressUpdateV2.checkoutUserErrors.length > 0) {
            $(".shipping-error-msg").text(result.data.checkoutShippingAddressUpdateV2.checkoutUserErrors[0].message);
            $(".shipping-error-msg").show();
            return false;
        }

      //AK code
      if(!email){
        var error = '<p class="error_msg">Enter Email</p>';
        $(error).insertAfter('#shipping_address_email');
        return false;
      }else if(!validRegex.test(email)){
        var error = '<p class="error_msg">Enter Valid Email</p>';
        $(error).insertAfter('#shipping_address_email');
        return false;
      }

      if(!shippingAddress.phone){
        var error = '<p class="error_msg">Enter Phone Number</p>';
        $(error).insertAfter('#shipping_address_phone');
        return false;
      }else if(!phone_regex.test(shippingAddress.phone) && !phone_regex_2.test(shippingAddress.phone) && !phone_regex_3.test(shippingAddress.phone)){
        var error = '<p class="error_msg">Enter Valid Phone Number</p>';
        $(error).insertAfter('#shipping_address_phone');
         return false;
      }
       
        return result;
    }).catch((error) => {
        console.log("update shipping => ", error);
        $(".shipping-error-msg").text("Something went wrong!").show();
    });
}


async function updateCheckoutObj(checkoutId) {
    fullCheckoutObj = await fetchCheckout(checkoutId);
    console.log("fullCheckoutObj => ", fullCheckoutObj);
    if ("errors" in fullCheckoutObj) {
        if (fullCheckoutObj.errors.length > 0) {
        // $('.shipping-error-msg').text(fullCheckoutObj.errors[0].message).show();
        }
    } else {
        nextStep = true;
    }

    if (Object.keys(fullCheckoutObj.data.node.lineItemsSubtotalPrice).length > 0) {
        checkoutSubTotal = Number(fullCheckoutObj.data.node.lineItemsSubtotalPrice.amount).toFixed(2);
        $(".cart_subtotal").find(".cart_subtotal_small").text(fullCheckoutObj.data.node.currencyCode  + " " + checkoutSubTotal);
    }
    console.log(fullCheckoutObj.data.node.availableShippingRates);
    if (fullCheckoutObj.data.node.availableShippingRates != null) {
      if (fullCheckoutObj.data.node.availableShippingRates.shippingRates.length > 0) {
        if (Object.keys(fullCheckoutObj.data.node.availableShippingRates.shippingRates[0].priceV2).length > 0) {
            checkoutShippingAmount = Number(fullCheckoutObj.data.node.availableShippingRates.shippingRates[0].priceV2.amount).toFixed(2);
            $(".cart_shipping").find(".cart_shipping_small").text(fullCheckoutObj.data.node.currencyCode + " " + checkoutShippingAmount);

            $("#shipping-method").find(".custom-radio label").text(fullCheckoutObj.data.node.availableShippingRates.shippingRates[0].title);
            $("#shipping-method").find(".custom-radio span").text(fullCheckoutObj.data.node.currencyCode + " " + checkoutShippingAmount);

            shippingRateHandle = fullCheckoutObj.data.node.availableShippingRates.shippingRates[0].handle;
            await updateShippingLine(checkoutId,shippingRateHandle);
        }
      }
    }

    if (fullCheckoutObj.data.node.discountApplications.edges.length > 0) {
        if (fullCheckoutObj.data.node.discountApplications.edges[0].node != null) {
            if (Object.keys(fullCheckoutObj.data.node.discountApplications.edges[0].node.value).length > 0) {
                discountTypeArray = Object.keys(fullCheckoutObj.data.node.discountApplications.edges[0].node.value);
                discountType = discountTypeArray[0];

                if (discountType == "percentage") {
                    disountAmount = ((Number(checkoutSubTotal)*Number(fullCheckoutObj.data.node.discountApplications.edges[0].node.value[discountType])) /100).toFixed(2);
                } else {
                    disountAmount = fullCheckoutObj.data.node.discountApplications.edges[0].node.value[discountType];
                }

                discountCodeObj = [{
                    code: discountCode,
                    type: discountType,
                    amount: fullCheckoutObj.data.node.discountApplications.edges[0].node.value[discountType]
                }];
            }
        }

        $(".cart_discount").find(".discount-text span b").text(discountCode);
        $(".cart_discount").find(".cart_discount_small").text("-"+ fullCheckoutObj.data.node.currencyCode + " " +disountAmount);
        $(".cart_discount").show();

        // clear discount code
        $("#discount_code").val("");

        //remove discount box
        $(".coup-code-form").removeClass("open");
        $(".app-coupon").removeClass("active");  

        // add tag on screen
        $(".discount-box").find("span.discount-text").find("span b").text(discountCode);
        $(".discount-box").find("span.discount-text").show();
    } else {
        disountAmount = 0;
        $(".cart_discount").find(".discount-text span b").text("");
        $(".cart_discount").find(".cart_discount_small").text("");
        $(".cart_discount").hide();

        $(".discount-box").find("span.discount-text").find("span b").text("");
        $(".discount-box").find("span.discount-text").hide();
    }

    
    checkoutTotal = (Number(checkoutSubTotal) + Number(checkoutShippingAmount) - Number(disountAmount)).toFixed(2);
    $(".cart_total").find(".total-right span").text(fullCheckoutObj.data.node.currencyCode  + " " + checkoutTotal);
}

// checout button count
if (window.matchMedia("(max-width: 768px)").matches) {
  var check_f_height = $('.fix_footer').height() + 20;
  $('.cstm-check_btn').css('bottom',check_f_height+'px');
}




